import { IconButton } from "@material-ui/core";
import { Container, BrandContainer } from "./styles";
import DehazeIcon from "@material-ui/icons/Dehaze";

const BrandTitle: React.FC<{
  setOpenMenu: any;
  openMenu: boolean;
}> = (props) => {
  const { setOpenMenu, openMenu } = props;

  return (
    <Container>
      <BrandContainer className="flex justify-center gap-3">
        {openMenu ? <img src="../img/logo.svg" alt="logo" /> : ""}
        <IconButton onClick={() => setOpenMenu(!openMenu)}>
          <DehazeIcon className="cursor-pointer" color="primary" />
        </IconButton>
      </BrandContainer>
    </Container>
  );
};

export default BrandTitle;
